module.exports = __webpack_public_path__ + "static/AkkuratPro-Bold-abde1d54cb2f71ec383d6f427f91ff30.woff2";